<template>
    <div>
        <form id="payment-form" @submit.prevent="submit">
            <!--<div id="link-authentication-element">
                &lt;!&ndash;Stripe.js injects the Link Authentication Element&ndash;&gt;
            </div>-->
            <div id="payment-element" class="tw-mb-2">
                <!--tripe.js injects the Payment Element -->
            </div>
            <button id="submit" v-if="isMounted" :disabled="showSpinner" class="btn btn-md btn-primary btn-fw">
                <loader v-if="showSpinner" :size="16" :border-width="4" />
                <span id="button-text" v-else>{{ translate('stripe.button.pay_now') }}</span>
            </button>
            <loader v-else :size="32" :border-width="8" />
            <div id="payment-message" :class="{ hidden: !errorMessage }" class="warning-text">
                {{ errorMessage }}
            </div>
        </form>
        <div
            class="tw-text-sm tw-leading-tight tw-text-center tw-border tw-border-solid tw-border-blue tw-rounded-4 tw-p-4 tw-text-dark-grey tw-mt-8 support-message"
            v-html="translate('booking.payment_error', { phone: phoneLink, email: emailLink })"
        ></div>
        <div class="payment-logos tw-mt-8">
            <img
                src="@/images/connect/mastercard.svg"
                class="tw-rounded-4 tw-border tw-border-solid tw-border-grey-300 tw-mr-1"
                alt="Mastercard"
            />
            <img
                src="@/images/connect/maestro.svg"
                class="tw-rounded-4 tw-border tw-border-solid tw-border-grey-300 tw-mx-1"
                alt="Maestro"
            />
            <img
                src="@/images/connect/visa.svg"
                class="tw-rounded-4 tw-border tw-border-solid tw-border-grey-300 tw-mx-1"
                alt="Visa"
            />
            <img
                src="@/images/connect/apple-pay.svg"
                class="tw-rounded-4 tw-border tw-border-solid tw-border-grey-300 tw-mx-1"
                alt="Apple Pay"
            />
            <img
                src="@/images/connect/google-pay.svg"
                class="tw-rounded-4 tw-border tw-border-solid tw-border-grey-300 tw-ml-1"
                alt="Google Pay"
            />
        </div>
        <div
            class="tw-p-2 tw-font-semibold tw-flex tw-flex-row tw-items-center tw-text-center tw-justify-center tw-text-dark-green tw-mt-4"
        >
            <img src="@/images/safe-payment-green.svg" alt="Safe Payment" class="tw-mr-2" />
            <span>{{ translate('customerInfoAndPayment.payment.safe_payment') }}</span>
        </div>
    </div>
</template>

<script>
import i18n from '@js/vue/mixins/i18n';
import { loadStripe } from '@stripe/stripe-js/pure';
import { mapGetters } from 'vuex';
import Loader from './shared/Loader.vue';
import { trackBookingSuccesfull, trackQrCodeBookingSuccesfull } from '@js/vue/dataLayerUtils';
import { contactInfo } from '@js/vue/contact-info.js';

export default {
    name: 'Stripe',
    mixins: [i18n],
    inject: ['lang', 'translations'],
    emits: ['successBooking', 'error'],
    components: { Loader },
    props: {
        id: Number,
    },
    data() {
        return {
            errorMessage: '',
            showSpinner: false,
            elements: {},
            paymentElement: {},
            isMounted: false,
            clientSecret: '',
            phoneLink: `<a class="tw-whitespace-nowrap tw-underline" href="tel:${contactInfo.phoneNumber}">${contactInfo.phoneNumber}</a>`,
            emailLink: `<a class="tw-whitespace-nowrap tw-underline" href="mailto:${contactInfo.emailAddress}">${contactInfo.emailAddress}</a>`,
        };
    },
    computed: {
        ...mapGetters('booking', ['getCustomerCountry', 'getRegionCategorySlugs', 'getTotalPrice', 'getServiceTitle']),
        customerCountry() {
            return this.getCustomerCountry;
        },
        title() {
            return this.getServiceTitle;
        },
        regionCategorySlugs() {
            return this.getRegionCategorySlugs;
        },
        totalPrice() {
            return this.getTotalPrice;
        },
    },
    methods: {
        async initialize() {
            loadStripe.setLoadParameters({ advancedFraudSignals: false });
            window.stripe = await loadStripe(window.STRIPE_KEY);
            const response = await axios.post(`/booking/${this.id}/payment-intent`);

            this.clientSecret = response.data;
            const appearance = {
                theme: 'stripe',
            };
            const { clientSecret } = this.clientSecret;
            this.elements = stripe.elements({ appearance, clientSecret });
            this.paymentElement = this.elements.create('payment', {
                fields: {
                    billingDetails: {
                        address: {
                            country: 'never',
                        },
                    },
                },
            });
            this.paymentElement.mount('#payment-element');
            this.paymentElement.on('ready', (event) => {
                this.isMounted = true;
            });
        },
        async submit() {
            let elements = this.elements;
            const { error } = await stripe.confirmPayment({
                elements,
                confirmParams: {
                    payment_method_data: {
                        billing_details: {
                            address: {
                                country: null,
                            },
                        },
                    },
                },
                redirect: 'if_required',
            });
            if (error) {
                // Display "error.message" to the user...
                this.errorMessage = error.message;
                return;
            }

            const { paymentIntent } = await stripe.retrievePaymentIntent(this.clientSecret.clientSecret);

            const data = {
                paymentIntentId: paymentIntent.id,
                onlinePayment: true,
            };
            this.showSpinner = true;
            axios
                .post(`/booking/${this.id}/process`, data)
                .then((response) => {
                    this.$emit('successBooking');
                    trackBookingSuccesfull(
                        this.title,
                        this.regionCategorySlugs['region-slug'],
                        this.regionCategorySlugs['category-slug'],
                        this.totalPrice
                    );

                    const utmParams = ['utm_source', 'utm_medium', 'utm_content'];

                    const { utmValues, hasUtmData } = utmParams.reduce((acc, param) => {
                        const value = localStorage.getItem(param);
                        if (value) acc.hasUtmData = true;
                        acc.utmValues[param] = value || '';
                        return acc;
                    }, { utmValues: {}, hasUtmData: false });                    

                    if (hasUtmData) {
                        trackQrCodeBookingSuccesfull(
                            this.title,
                            utmValues['utm_medium'],
                            utmValues['utm_source'],
                            utmValues['utm_content'],
                            this.totalPrice
                            );
                        }
                })
                .catch((error) => {
                    this.errorMessage = error.response.data.errors[0] || error.response.data.message;
                    const { status } = error.response;
                    if (status === 419 || status === 404) {
                        // 419 csrf token mismatch (session expired)
                        // 404 cart not in session (probably expired session)
                        this.$emit('error', 'session_expired');
                    } else {
                        // something else went wrong
                        this.$emit('error', 'something_went_wrong');
                    }
                })
                .finally(() => (this.showSpinner = false));
        },
    },
    mounted() {
        this.initialize();
    },
};
</script>

<style scoped>
form {
    align-self: center;
    box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1), 0px 2px 5px 0px rgba(50, 50, 93, 0.1),
        0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
    border-radius: 7px;
    padding: 1rem;
}

.hidden {
    display: none;
}

#payment-message {
    color: rgb(105, 115, 134);
    font-size: 16px;
    line-height: 20px;
    padding-top: 12px;
    text-align: center;
}

button:disabled {
    opacity: 0.5;
    cursor: default;
}

.payment-logos {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

@-webkit-keyframes loading {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@keyframes loading {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@media only screen and (max-width: 600px) {
    form {
        min-width: initial;
    }
}
</style>
